export { Card as IntegrationCard } from './card'
